import styled from "styled-components";
import { FormWrapper, OrangeAccentCard } from "../../styles/shared";
import TableContainer from '@mui/material/TableContainer';
import CustomButton from "../../components/Form/Button";

export const StockMovementWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
`;

export const PageHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 0 0 0;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  
  @media (min-width: 768px) {
    padding: 24px 0 0 0;
    margin-bottom: 32px;
  }
  
  h1 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    @media (min-width: 768px) {
      font-size: 32px;
      gap: 12px;
    }
    
    i {
      color: #f29205;
      font-size: 28px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
      
      @media (min-width: 768px) {
        font-size: 36px;
      }
    }
    
    .badge {
      background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
      color: #ffffff;
      padding: 4px 10px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 700;
      margin-left: 8px;
      box-shadow: 0 2px 8px rgba(242, 146, 5, 0.3);
      
      @media (min-width: 768px) {
        padding: 6px 12px;
        font-size: 16px;
        margin-left: 12px;
      }
    }
  }
`;

export const NewMovementButton = styled.a`
  background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
  color: #ffffff !important;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 600;
  text-decoration: none !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 15px rgba(242, 146, 5, 0.3);
  transition: all 0.3s ease;
  font-size: 14px;
  height: 44px;
  
  @media (min-width: 768px) {
    padding: 12px 24px;
    gap: 8px;
    font-size: 16px;
    height: auto;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(242, 146, 5, 0.4);
    color: #ffffff !important;
    text-decoration: none !important;
  }
  
  i {
    font-size: 14px;
    
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const StockMovementCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
`;

export const FilterSection = styled.div`
  padding: 20px 16px;
  
  @media (min-width: 768px) {
    padding: 32px;
  }
`;

export const FilterTitle = styled.div`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  
  @media (min-width: 768px) {
    font-size: 18px;
    margin-bottom: 20px;
    gap: 10px;
  }
  
  i {
    font-size: 18px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));
    
    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 24px 16px 0 16px;
  
  @media (min-width: 768px) {
    padding: 24px 24px 0 24px;
  }
  
  @media (min-width: 1200px) {
    padding: 24px 72px 0 72px;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(242, 146, 5, 0.2) !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch !important;
  
  /* Scrollbar styling */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(242, 146, 5, 0.5);
    border-radius: 4px;
    
    &:hover {
      background: rgba(242, 146, 5, 0.7);
    }
  }
  
  .MuiTable-root {
    background: transparent !important;
    min-width: 600px !important;
    
    @media (min-width: 768px) {
      min-width: 650px !important;
    }
  }
  
  .MuiTableHead-root {
    background: rgba(242, 146, 5, 0.1) !important;
    
    .MuiTableCell-head {
      color: #f29205 !important;
      font-weight: 700 !important;
      border-bottom: 2px solid rgba(242, 146, 5, 0.3) !important;
      padding: 12px 8px !important;
      white-space: nowrap !important;
      
      @media (min-width: 768px) {
        padding: 16px !important;
      }
    }
  }
  
  .MuiTableBody-root {
    .MuiTableRow-root {
      transition: all 0.2s ease !important;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
      
      &:hover {
        background: rgba(242, 146, 5, 0.05) !important;
      }
      
      .MuiTableCell-body {
        color: #e0e0e0 !important;
        padding: 12px 8px !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
        
        @media (min-width: 768px) {
          padding: 16px !important;
        }
      }
    }
  }
  
  .MuiTableFooter-root {
    background: rgba(242, 146, 5, 0.05) !important;
    
    .MuiTableCell-footer {
      border-top: 2px solid rgba(242, 146, 5, 0.3) !important;
      padding: 12px 8px !important;
      
      @media (min-width: 768px) {
        padding: 16px !important;
      }
    }
  }
`;

export const ProductImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid rgba(242, 146, 5, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    width: 50px;
    height: 50px;
  }
  
  &:hover {
    border-color: rgba(242, 146, 5, 0.6);
    transform: scale(1.1);
    box-shadow: 0 0 15px rgba(242, 146, 5, 0.3);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  svg {
    color: #888;
    font-size: 24px;
    
    @media (min-width: 768px) {
      font-size: 32px;
    }
  }
`;

export const ProductInfo = styled.div`
  min-width: 0;
  flex: 1;
  
  .product-name {
    color: #ffffff;
    font-weight: 600;
    margin-bottom: 4px;
    font-size: 14px;
    
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
  
  .product-details {
    color: #b0b0b0;
    font-size: 11px;
    line-height: 1.4;
    
    @media (min-width: 768px) {
      font-size: 12px;
    }
  }
`;

export const MovementBadge = styled.span`
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 14px;
  display: inline-block;
  
  &.badge-success {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  }
  
  &.badge-danger {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .MuiIconButton-root {
    color: #00d4ff !important;
    transition: all 0.2s ease !important;
    
    &:hover {
      background: rgba(0, 212, 255, 0.1) !important;
      transform: scale(1.1);
    }
    
    &[aria-label="delete"] {
      color: #ff6b6b !important;
      
      &:hover {
        background: rgba(255, 107, 107, 0.1) !important;
      }
    }
  }
`;

export const PaginationInfo = styled.span`
  color: #b0b0b0;
  font-size: 14px;
  padding: 12px 16px;
  display: inline-block;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  color: #e0e0e0;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  
  &:hover:not(:disabled) {
    background: rgba(242, 146, 5, 0.1);
    border-color: rgba(242, 146, 5, 0.3);
    color: #f29205;
    transform: translateY(-2px);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingButton = styled(CustomButton)`
  width: 100%;
  background: rgba(255, 255, 255, 0.05) !important;
  border: 2px solid rgba(255, 255, 255, 0.1) !important;
  color: #e0e0e0 !important;
`;

export const EmptyState = styled.div`
  padding: 32px;
  
  .MuiAlert-root {
    background: rgba(242, 146, 5, 0.1) !important;
    border: 1px solid rgba(242, 146, 5, 0.3) !important;
    color: #f29205 !important;
    border-radius: 12px !important;
  }
`;

export const TableWrapper = styled.div`
  padding: 16px;
  padding-top: 0;
  
  @media (min-width: 768px) {
    padding: 32px;
    padding-top: 0;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
  
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const FilterInputWrapper = styled.div`
  flex: 1;
  width: 100%;
  
  @media (max-width: 767px) {
    width: 100%;
  }
  
  @media (min-width: 768px) {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
`;

export const FilterButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 767px) {
    width: 100%;
    
    button,
    .mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
  
  @media (min-width: 768px) {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    justify-content: flex-start;
  }
`;

export const StyledFilterFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root {
        height: 48px !important;
        min-height: 48px !important;
        
        .MuiInputBase-input {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }
      
      .MuiInputLabel-root {
        font-size: 14px !important;
      }
    }
  }
`;

// Exportando FormWrapper compartilhado
export { FormWrapper };





